import { reactive, ref } from 'vue'
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
import { toast, variant } from '@/core/helper/utility'
import { httpStatusCode } from '@/core/helper/httpStatusCode';
import { GetAll, Create } from '@/infrastructure/repositories/setupWhatsappRepository';

export const useWhatsappConfiguration = () => { 
    var filter = reactive({ });

    const configurationInitialState = {
        phone: null,
        accountId: null,
        accountKey: null,
        idBrand: null,
    };

    var configuration = reactive({
        ...configurationInitialState
    });

    const configurationRules = {
        phone: {
            required
        },
        accountId: {
            required
        },
        accountKey: {
            required
        },
        idBrand: {
            required
        }
    };

    var isLoading = ref(false);
    var isCreateLoading = ref(false);
    var configurations = ref([]);
    

    const validate$ = useVuelidate(configurationRules, configuration, { $scope: false });

    const onCreateHandle = async () => {
        try {
            const isValid = await validate$.value.$validate();
            if(!isValid){
                return;
            }

            isCreateLoading.value = true;
            const response = await Create(configuration);

            if(response.status == httpStatusCode.OK){
                toast({
                    variant: variant.success,
                    title: response.data.title,
                    body:  response.data.message
                });
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }

            isCreateLoading.value = false;
        } catch (error) {
            isCreateLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Setup Whatsapp',
                body: 'Could not create setup whatsapp, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    };

    // const onUpdateHandle = async () => {
    //     try {
    //         const isValid = await validate$.value.$validate();
    //         if(!isValid){
    //             return;
    //         }

    //         isCreateLoading.value = true;
    //         const response = await Update(configuration);

    //         if(response.status == httpStatusCode.OK){
    //             toast({
    //                 variant: variant.success,
    //                 title: response.data.title,
    //                 body:  response.data.message
    //             });
    //         }else{
    //             toast({
    //                 collection: true,
    //                 variant: variant.error,
    //                 title: response.data.title,
    //                 body:  response.data.messages
    //             });
    //         }

    //         isCreateLoading.value = false;
    //     } catch (error) {
    //         isCreateLoading.value = false;
    //         toast({
    //             variant: variant.error,
    //             title: 'Setup Whatsapp',
    //             body: 'Could not create setup whatsapp, check again, please contact support center'
    //         });
    
    //         throw new Error(error);
    //     }
    // };


    const getWhatsappConfigurations = async (params) => {
        try {
            isLoading.value = true;

            const response = await GetAll({
                ...filter,
                ...params
            });

            if(response.status == httpStatusCode.OK){
                configurations.value = response.data.value;
            }else{
                toast({
                    collection: true,
                    variant: variant.error,
                    title: response.data.title,
                    body:  response.data.messages
                });
            }

            isLoading.value = false;
        } catch (error) {
            isLoading.value = false;
            toast({
                variant: variant.error,
                title: 'Setup Whatsapp',
                body: 'Could not get setup whatsapp list, check again, please contact support center'
            });
    
            throw new Error(error);
        }
    }

    return {
        validate$,
        isLoading,
        isCreateLoading,
        configuration,
        configurations,
        onCreateHandle,
        getWhatsappConfigurations,
    }
}